<template>
	<div class="cardManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">电卡管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">电卡列表</span>
					<div>总押金金额：<span>{{allCardDeposit}}</span>元</div>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新增电卡"></div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.cardNumber" placeholder="请输入卡号">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.userName" placeholder="请输入用户名">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.bindStatus" slot="prepend" placeholder="请选择绑定状态">
								<el-option v-for="(item,inx) in bindList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.signsFlag" slot="prepend" placeholder="请选择物流状态">
								<el-option v-for="(item,inx) in logisticsList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.cardStatus" slot="prepend" placeholder="请选择使用状态">
								<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="cardNo" label="卡硬件编号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="cardNumber" label="卡号">
								<!-- <template slot-scope="scope">
									<div class="disCenter clickUndline" @click="changeNo(scope.row)"
										v-if="scope.row.cardNo">
										<span>{{scope.row.cardNumber}}</span>
										<span title="修改编号" class="money_add"></span>
									</div>
									<div v-else>
										<span>{{scope.row.cardNumber}}</span>
									</div>
								</template> -->
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="userName" label="用户名" width="130">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="bindtime" label="上次使用时间" width="160">
								<template slot-scope="scope">
									<span v-if="scope.row.bindtime">{{scope.row.bindtime}}</span>
									<span v-else>{{scope.row.createTime}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="cardAccount" label="充值金额" width="120">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="extraCardAccount" label="赠送金额" width="120">
								<template slot-scope="scope">
									<div class="disStart">
										<span>{{scope.row.extraCardAccount}}</span>
										<span title="添加赠送金" class="money_add" @click="addMoney(scope.row)"></span>
									</div>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="cardDeposit" label="押金" width="120">
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip prop="cardValidityPeriod" label="有效期" width="140">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="expressNumber" label="订单号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="signsFlag" label="物流状态">
								<template slot-scope="scope">
									<span>{{scope.row.signsFlag==1?"未发货":scope.row.signsFlag==2?"已发货":scope.row.signsFlag==3?"已签收":''}}</span>
								</template>
							</el-table-column> -->
							<el-table-column show-overflow-tooltip prop="bindStatus" label="绑定状态" width="110">
								<template slot-scope="scope">
									<span v-if="scope.row.cardNo">已绑定</span>
									<span v-else>未绑定</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="cardStatus" label="使用状态" width="120">
								<template slot-scope="scope">
									<span>{{getName(scope.row.cardStatus,statusList)}}</span>
								</template>
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip prop="bindTime" label="绑定时间" width="140">
							</el-table-column> -->
							<el-table-column label="操作" width="70">
								<template slot-scope="scope">
									<el-popover class="mypopover disCenter" placement="top-end" width="100"
										trigger="hover" v-if="scope.row.cardNo">
										<div class="pupBox">
											<span class="hoverClass" @click.stop="itemClick(scope.row,3)">详情</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,6)">赠送金记录</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,1)">编辑</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,2)">删除</span>
										</div>

										<div slot="reference" class="itemRight listIcon"></div>
									</el-popover>
									<div class="pupBox" v-else>
										<span class="hoverClass2" @click.stop="itemClick(scope.row,4)">绑定</span>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="卡硬件编号">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.cardNo" placeholder="请输入卡硬件编号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="卡号">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.cardNumber" type="Number" placeholder="请输入卡号">
									</el-input>
								</div>
							</el-form-item>
						</div>

					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="用户名">
								<div class="myinputBox">
									<el-input  v-model="creatObj.userName" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="充值金额">
								<div class="myinputBox">
									<el-input v-model="creatObj.cardAccount"  type="Number"
										placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>

					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="手机号">
								<div class="myinputBox">
									<el-input  v-model="creatObj.phone" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="地址">
								<div class="myinputBox">
									<el-input v-model="creatObj.address"  
										placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
					
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="赠送金额" >
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.extraCardAccount" type="Number" placeholder="请输入赠送金额">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="押金">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.cardDeposit"  type="Number" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>


					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="有效期" prop="cardValidityPeriod">
								<div class="myinputBox">
									<el-date-picker v-model="creatObj.cardValidityPeriod" type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
									</el-date-picker>
									<!-- <el-input  v-model="creatObj.cardValidityPeriod" placeholder="请输入有效期">
									</el-input> -->
								</div>
							</el-form-item>
						</div>

						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="绑定时间">
								<div class="myinputBox">
									<el-input  v-model="creatObj.bindTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>


					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="使用状态">
								<div class="myinputBox">
									<el-select clearable value-key="value"  v-model="creatObj.cardStatus"
										slot="prepend" placeholder="请选择使用状态">
										<el-option v-for="(item,inx) in statusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="物流状态" prop="signsFlag">
								<div class="myinputBox">
									<el-select clearable value-key="value" v-model="creatObj.signsFlag" slot="prepend"
										placeholder="请选择物流状态">
										<el-option v-for="(item,inx) in logisticsList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>

					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart" v-if="creatObj.signsFlag>1">
							<el-form-item class="lableBox" label="订单号" prop="expressNumber">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.expressNumber" placeholder="请输入订单号">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
		<el-dialog title="电卡信息" center class="mydialog" :visible.sync="dialogVisible2" width="60%">
			<div class="dialogBox3">
				<div class="contBox">
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">卡硬件编号:</span>
							<span class="valueBox">{{creatObj.cardNo}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">卡号:</span>
							<span class="valueBox">{{creatObj.cardNumber}}</span>
						</div>
					</div>

					<div class="itemBox  disStart">
						<div class="elBox">
							<span class="nameBox">用户名:</span>
							<span class="valueBox">{{creatObj.userName}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">充值金额(元):</span>
							<span class="valueBox">{{creatObj.cardAccount}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox">
							<span class="nameBox">手机号:</span>
							<span class="valueBox">{{creatObj.phone}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">地址:</span>
							<span class="valueBox">{{creatObj.address}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">赠送金额(元):</span>
							<span class="valueBox">{{creatObj.extraCardAccount}}</span>
						</div>
						<div class="elBox ">
							<span class="nameBox">押金(元):</span>
							<span class="valueBox">{{creatObj.cardDeposit}}</span>
						</div>

					</div>

					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">有效期:</span>
							<span class="valueBox">{{creatObj.cardValidityPeriod}}</span>
						</div>
						<div class="elBox ">
							<span class="nameBox">绑定状态:</span>
							<span class="valueBox">{{creatObj.cardNo?'已绑定':'未绑定'}}</span>
						</div>


					</div>
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">绑定时间:</span>
							<span class="valueBox">{{creatObj.bindTime}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">物流状态:</span>
							<span class="valueBox">{{getName(creatObj.signsFlag,logisticsList)}}</span>
						</div>

					</div>
					<div class="itemBox  disStart">
						<div class="elBox">
							<span class="nameBox">使用状态:</span>
							<span class="valueBox">{{getName(creatObj.cardStatus,statusList)}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">订单号:</span>
							<span class="valueBox">{{creatObj.expressNumber}}</span>
						</div>
					</div>
				</div>

			</div>

			<div slot="footer" class="diabtnBox">
				<el-button type="primary" @click="dialogVisible2 = false">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="修改卡号" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow2"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4 ">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="卡号" prop="cardNumber">
								<div class="myinputBox">
									<el-input v-model="creatObj.cardNumber" type="Number"
										placeholder="请输入卡号"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow2=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm2')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="新增电卡" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="addCardShow"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="电卡数量" prop="totalNumber">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.totalNumber,50)"
										v-model="creatObj.totalNumber" type="Number" placeholder="请输入电卡数量"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="addCardShow=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="绑定电卡编号" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="cardBindShow"
			width="50%">
			<span class="rush" @click="getLoad" title="点击刷新电卡编号列表"></span>
			<el-form :model="creatObj" :rules="rules" ref="ruleForm5" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4">
					<div class="diaItem disStart cardList" v-loading="cardLoading">
						<!-- <div class="diaTpye disStart">
							<el-form-item class="lableBox" label="电卡编号" prop="cardId">
								<div class="myinputBox">
									<el-select clearable v-model="creatObj.cardId" placeholder="请选择电卡编号">
										<div v-infinite-scroll="getLoad" :infinite-scroll-disabled="busy" >
											<el-option v-for="item in cardNoList" :key="item.cardId" :label="item.cardNo"
												:value="item.cardId">
											</el-option>
										</div>

									</el-select>
								</div>
							</el-form-item>
						</div> -->
						<div v-for="(item,inx) in cardNoList" :key="inx" class="cardItem"
							:class="{active:inx==activeInx}" v-if="activeInx>=0">
							<p class="">编号：{{item.cardNo}}</p>
							<p class="">读卡时间：{{item.readCardTime}}</p>
						</div>
						<div v-if="activeInx<=0" class="nodata">暂无可绑定的电卡编号</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="cardBindShow=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm5')">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="添加赠送金" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow3"
			width="40%">
			<el-form :model="moneyObj" :rules="rules" ref="ruleForm6" label-width="100px" class="demo-ruleForm">
				<div class=" dialogBox5">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="赠送金" prop="accountExtraBalance">
								<div class="myinputBox">
									<el-input @input="numberChange(moneyObj.accountExtraBalance,20,1)"
										v-model="moneyObj.accountExtraBalance" type="text" placeholder="请输入赠送金"
										oninput="value=value.replace(/[^\d]/g,'')"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="备注" prop="remark">
								<div class="myinputBox">
									<el-input v-model="moneyObj.remark" placeholder="请输入备注"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow3=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm6')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="赠送金记录" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogOperation3" width="80%">
			<div class="dialogBox dialogBox2 dialogBox6">
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%" height="450">
						<el-table-column type="index" label="序号">
							
						</el-table-column>
						<el-table-column prop="loginName" label="操作人">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="extraCardAccount" label="赠送金额">
						</el-table-column>
						
						<el-table-column show-overflow-tooltip prop="createTime" label="时间">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="remark" label="备注">
						</el-table-column>
					</el-table>
				</div>
				<!-- <div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,3)">
					</el-pagination>
				</div> -->
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation3= false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>


<script >
	export default {
		
		data() {
			var checkNum = (rule, value, callback) => {
							setTimeout(() => {
								if (isNaN(parseFloat(value))) {
									callback(new Error('请输入数字值'));
								} else {
									callback();
								}
							}, 500);
						};
			return{
				PageInfo: {
									pagesize: 10,
									pagenum: 1,
									total: 0
								},
								allCardDeposit: 0,
								creatObj: {},
								loading2: false,
								operationData: [],
								OperationInfo: {
									pagesize: 10,
									pagenum: 1,
									total: 0
								},
								dialogVisible: false,
								dialogVisible2: false,
								visibleShow2: false,
								visibleShow3: false,
								addCardShow: false,
								cardBindShow: false,
								dialogOperation3: false,
								NOfalse: false,
								activeInx: 0,
								busy: false, //懒加载状态
								cardNoList: [],
								cardLoading: false,
								dialogTitle: "新增卡号",
								logisticsList: [{
										text: "未发货",
										value: 1
									},
									{
										text: "已发货",
										value: 2
									},
									{
										text: "已签收",
										value: 3
									},
								],
								bindList: [{
										text: "已绑定",
										value: 2
									},
									{
										text: "未绑定",
										value: 1
									}
								],
								statusList: [{
										text: "未开通",
										value: 1
									},
									{
										text: "已开通(正常)",
										value: 2
									},
									{
										text: "被冻结",
										value: 3
									}
								],
								tableData: [],
								loading: false,
								searchObj: {
									search: "", //搜索
									roleId: "", //角色id
									serviceProviderId: "", //运营商id
									loginStatus: null, //账号状态 1使用中 2禁用
									pageNo: 1, //当前页
									pageSize: 10, //当前页个数
								},
								searchObj2:{
									cardId:""
								},
								rules: {
									cardAccount: [{
											validator: checkNum,
											trigger: 'blur'
										},
										{
											required: true,
											message: '请输入充值金额',
											trigger: 'blur'
										}
									],
									extraCardAccount: [{
											validator: checkNum,
											trigger: 'blur'
										},
										{
											required: true,
											message: '请输入赠送金额',
											trigger: 'blur'
										}
									],
									cardValidityPeriod: [{
										required: true,
										message: '请选择有效期',
										trigger: 'change'
									}],
									expressNumber: [{
										required: true,
										message: '请输入订单号',
										trigger: 'blur'
									}],
									cardStatus: [{
										required: true,
										message: '请选择使用状态',
										trigger: 'change'
									}],
									signsFlag: [{
										required: true,
										message: '请选择物流状态',
										trigger: 'change'
									}],
									cardId: [{
										required: true,
										message: '请选择电卡编号',
										trigger: 'change'
									}],
									expressNumber: [{
										required: true,
										message: '请输入订单号',
										trigger: 'blur'
									}],
									cardNumber: [{
											validator: checkNum,
											trigger: 'blur'
										},
										{
											required: true,
											message: '请输入卡号',
											trigger: 'blur'
										}
									],
									accountExtraBalance: [{
											validator: checkNum,
											trigger: 'blur'
										},
										{
											required: true,
											message: '请输入赠送金',
											trigger: 'blur'
										}
									],
									remark: [{
										required: true,
										message: '请输入备注',
										trigger: 'blur'
									}],
								},
								moneyObj: {
									accountExtraBalance: "",
									remark: ""
								},
								cardObj: {
									pageNo: 1,
									pageSize: 10,
								}
			}
		},
		mounted() {
					this.$nextTick(() => {
						this.getData()
						this.countCardDeposit()
					})
				},
				methods: {
					addMoney(item) {
						this.$set(this, "moneyObj", {
							accountExtraBalance: "",
							remark: "",
							cardId: item.cardId
						})
						this.visibleShow3 = true
						this.$nextTick(() => {
							this.$refs.ruleForm6.clearValidate()
						})
					},
					countCardDeposit(){
						this.$api.countCardDeposit({}).then((res)=>{
							if(res.returnCode==200){
								this.$set(this,"allCardDeposit",res.obj||0)
							}
						})
					},
					getLoad() {
						setTimeout(() => {
							this.getCardList()
						}, 500)
					},
					getCardList() {
						this.cardNoList = []
						this.busy = true
						this.activeInx = 0
						this.cardLoading = true
						this.$api.selectNoBindUserInfoCard(this.cardObj).then((res) => {
							if (res.returnCode == 200) {
								if (res.obj.list && res.obj.list.length > 0) {
									this.activeInx = 0
								} else {
									this.activeInx = -1
								}
								this.$set(this, "cardNoList", res.obj.list)
								this.cardLoading = false
								this.busy = false
							}
						})
					},
					linkCard() {
						if (this.activeInx < 0) {
							this.$message({
								message: '请选择需要绑定的电卡编号',
								type: 'warning'
							});
							return false
						}
						let obj = {
							cardNumber: this.creatObj.cardNumber,
							cardId: this.cardNoList[this.activeInx].cardId,
						}
						this.$api.linkCard(obj).then((res) => {
							if (res.returnCode == 200) {
								this.$message({
									message: '电卡绑定成功',
									type: 'success'
								});
								this.cardBindShow = false
								setTimeout(() => {
									this.getData()
								}, 500)
							}
						})
					},
					numberChange(val, maxNum,n ) {
						if(n==1){
							//转换数字类型
							let num = Number(val)
							if (num < 0) {
								this.$set(this.moneyObj, "accountExtraBalance", 0)
							}
							if (num > 100) {
								this.$set(this.moneyObj, "accountExtraBalance", 100)
							}
						}else{
							//转换数字类型
							let num = Number(val)
							if (num < 0) {
								this.$set(this.creatObj, "totalNumber", 0)
							}
							if (num > 1000) {
								this.$set(this.creatObj, "totalNumber", 1000)
							}
						}
						
					},
					getName(val, arr) {
						let obj = arr.find((item) => {
							return val == item.value
						})
						if(obj == undefined){
							return
						}else{
							return obj.text
						}
						// return obj.text
					},
					changeNo(obj) {
						this.$set(this, "creatObj", obj)
						this.visibleShow2 = true
					},
					// 保存按钮点击事件 新建/编辑
					toSave(formName) {
						let that = this
						this.$refs[formName].validate((valid) => {
							if (valid) {
		
								if (formName == "ruleForm4") {
									that.addUserInfoCard()
								} else if (formName == "ruleForm1") {
									that.updateUserInfoCard(that.creatObj)
								} else if (formName == "ruleForm5") {
									that.linkCard()
								}else if(formName=="ruleForm6"){
									let obj = {
										cardId: that.moneyObj.cardId,
										extraCardAccount: that.moneyObj.accountExtraBalance,
										remark: that.moneyObj.remark
									}
									that.$api.addExtraBalanceRecord(obj).then((res) => {
										if (res.returnCode == 200) {
											that.$message({
												type: 'success',
												message: '操作成功!'
											});
											this.visibleShow3 = false
											that.$nextTick(() => {
												that.getData()
											})
										}
									})
								}
							} else {
								return false;
							}
						});
		
					},
					updateUserInfoCard(item) {
						let obj = {
							cardNo: item.cardNo, //编号
							cardNumber: item.cardNumber, //编号
							cardAccount: item.cardAccount, //充值金额
							extraCardAccount: item.extraCardAccount, //赠送金额
							cardValidityPeriod: item.cardValidityPeriod, //有效期
							signsFlag: item.signsFlag, //1未发货 2已发货 3已签收
							// cardStatus: item.signsFlag == 3 ? item.cardStatus : "1", //1未开通 2已开通(正常)3被冻结
							cardStatus: item.cardStatus , //1未开通 2已开通(正常)3被冻结
							expressNumber: item.signsFlag > 1 ? item.expressNumber : "", //订单号
							cardNumber: item.cardNumber, //卡号
							phone: item.phone, //卡号
							address: item.address, //卡号
							userName: item.userName, //用户名
							cardAccount: item.cardAccount, //充值金额
						}
						this.$api.updateUserInfoCard(obj).then((res) => {
							if (res.returnCode == 200) {
								this.$nextTick(() => {
									this.visibleShow2 = false
									this.dialogVisible = false
									this.$message({
										message: '编辑电卡成功',
										type: 'success'
									});
									setTimeout(() => {
										this.getData()
									}, 500)
								})
							}
						})
					},
					addUserInfoCard(item) {
						let obj = {
							totalNumber: this.creatObj.totalNumber,
						}
						this.$api.addUserInfoCard(obj).then((res) => {
							if (res.returnCode == 200) {
								this.$nextTick(() => {
									this.addCardShow = false
									this.$message({
										message: '新增电卡成功',
										type: 'success'
									});
									setTimeout(() => {
										this.toSearch()
									}, 500)
								})
							}
						})
					},
					// 编辑1删除2新增5
					itemClick(item, n) {
						let that = this
						if (n == 1) {
							this.dialogTitle = "编辑电卡"
							this.$set(this, "creatObj", item)
							this.dialogVisible = true
							this.$nextTick(() => {
								this.$refs.ruleForm1.clearValidate()
							})
						} else if (n == 5) {
							this.$set(this, "creatObj", {
								totalNumber: "", //
							})
							this.addCardShow = true
							this.$nextTick(() => {
								this.$refs.ruleForm4.clearValidate()
							})
						} else if (n == 2) {
							this.$confirm('是否确认删除该电卡?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								that.$api.deleteUserInfoCard({
									cardNumber: item.cardNumber
								}).then((res) => {
									if (res.returnCode == 200) {
										that.$message({
											type: 'success',
											message: '删除成功!'
										});
										setTimeout(() => {
											that.toSearch()
										}, 500)
									}
								})
		
							}).catch(() => {
		
							});
						} else if (n == 3) {
							this.$set(this, "creatObj", item)
							this.dialogVisible2 = true
						} else if (n == 4) {
							this.getCardList()
							this.$set(this, "creatObj",item)
							this.cardBindShow = true
							this.$nextTick(() => {
								this.$refs.ruleForm5.clearValidate()
							})
						} else if (n == 6) {
							this.$set(this.searchObj2, "cardId", item.cardId)
							this.listExtraBalanceRecord()
						}
					},
		
					toSearch() {
						this.$set(this.PageInfo, "pagenum", 1)
						this.$set(this.searchObj, "pageNo", 1)
						this.$nextTick(() => {
							this.getData()
						})
					},
					getData() {
						this.loading = true
		
						this.$api.listUserInfoCard(this.searchObj).then((res) => {
							if (res.returnCode == 200) {
								this.loading = false
								this.$set(this, "tableData", res.obj.list || [])
								this.$set(this.PageInfo, "total", res.obj.total || 0)
							}
						})
					},
					// 选择分页
					handleCurrentChange(val) {
						this.$set(this.PageInfo, "pagenum", val)
						this.$set(this.searchObj, "pageNo", val)
						this.getData({})
					},
					handleChange(value, n) {
						let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
						if (nodesInfo.length > 0) {
							this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
							this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
							this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
						}
					},
					listExtraBalanceRecord(){
						this.loading2 = true
						let obj = {
							pageNo: this.searchObj2.pageNo, //当前页
							pageSize: this.searchObj2.pageSize, //当前页个数
							cardId: this.searchObj2.cardId,
						}
						this.$api.listExtraBalanceRecord(obj).then((res) => {
							if (res.returnCode == 200) {
								this.loading2 = false
								// for (let k of res.obj) {
								// 	k.loginIdName = (k.loginId).slice(10)
								// }
								this.$set(this, "operationData", res.obj || [])
								// this.$set(this.OperationInfo, "total", res.obj.total || 0)
							}
						})
						this.dialogOperation3 = true
					},
					
					handleCurrentChange2(val, n) {
						this.$set(this.OperationInfo, "pagenum", val)
						this.$set(this.searchObj2, "pageNo", val)
						this.$nextTick(() => {
							
						})
					},
			}
		}
</script>
	
<style lang="scss" scoped>
	@import "./cardManage.scss";
</style>